import {ChartOutput, ChartQuery} from 'entities/chart';
import {ChartType, hierarchicalAggregationChartTypes} from '@/views/storyboard/utils/chartConstants';
import {isHierarchicalAggregationOutput} from '@/views/storyboard/charts/utils/aggregationsToSunburstTree';
import i18n from 'i18n';

export type ChartSettingsCompatibilityHintVariant = 'warning' | 'error';

export interface ChartSettingsCompatibilityHint {
    message: string;
    variant: ChartSettingsCompatibilityHintVariant;
}

export function getChartSettingsCompatibilityHints(
    chartType: ChartType,
    chartQuery: ChartQuery,
): ChartSettingsCompatibilityHint[] {
    const hints: ChartSettingsCompatibilityHint[] = [];
    const output = chartQuery.output;

    if (chartType === ChartType.BigNumber && output !== ChartOutput.TimelineByDate) {
        hints.push({
            message: i18n.t('chart_settings_bignumber_timeline_recommendation.text'),
            variant: 'warning',
        });
    }

    if (
        chartType === ChartType.PieChart
        && (
            output === ChartOutput.TermsTimeline
            || output === ChartOutput.MultiTermsTimeline
        )
    ) {
        hints.push({
            message: i18n.t('chart_settings_pie_timeline_recommendation.text'),
            variant: 'warning',
        });
    }

    if (
        hierarchicalAggregationChartTypes.includes(chartType)
        && isHierarchicalAggregationOutput(output)
        && (chartQuery.aggs_item_list?.length ?? 0) < 2
    ) {
        hints.push({
            message: i18n.t('chart_settings_hierarchical_multi_aggregation_error.text'),
            variant: 'error',
        });
    }

    return hints;
}
